namespace RioERP.Users {
    export interface CustomersForm {
        Name: Serenity.StringEditor;
        Mobile1: Serenity.StringEditor;
        EmailId1: Serenity.EmailEditor;
        CourseId: Serenity.LookupEditor;
        LevelId: Serenity.LookupEditor;
        AttemptId: Serenity.LookupEditor;
        Mobile2: Serenity.StringEditor;
        EmailId2: Serenity.EmailEditor;
        ECustomerType: Serenity.EnumEditor;
        Gstin: Serenity.StringEditor;
        CouponCode: Serenity.StringEditor;
        HasPurchased: Serenity.BooleanEditor;
    }

    export class CustomersForm extends Serenity.PrefixedContext {
        static formKey = 'Users.Customers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomersForm.init)  {
                CustomersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EmailEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(CustomersForm, [
                    'Name', w0,
                    'Mobile1', w0,
                    'EmailId1', w1,
                    'CourseId', w2,
                    'LevelId', w2,
                    'AttemptId', w2,
                    'Mobile2', w0,
                    'EmailId2', w1,
                    'ECustomerType', w3,
                    'Gstin', w0,
                    'CouponCode', w0,
                    'HasPurchased', w4
                ]);
            }
        }
    }
}
